
export class Area {
  public id: number = 0;
  public clientId: string = null;
  public parentClientId: number = null;
  public region: string = null;
  public parentRegionId: number = null;
  public location: string = null;
  public parentLocationId: number = null;
  public unit: string = null;
  public parentUnitId: number = null;
  public projectId: number = null;

  get isClient() {
    return !this.region && !this.location && !this.unit && !this.projectId;
  }
  set isClient(value) {}

  get isRegion() {
    return this.region && !this.location && !this.unit && !this.projectId;
  }
  set isRegion(value) {}

  get isLocation() {
    return this.location && !this.unit && !this.projectId;
  }
  set isLocation(value) {}

  get isUnit() {
    return this.unit && !this.projectId;
  }
  set isUnit(value) {}

  get isProject() {
    return this.projectId !== null;
  }
  set isProject(value) {}

  get parentId() {
    if (this.isClient) return null;

    if (this.isRegion) return this.parentClientId;

    if (this.isLocation) return this.parentRegionId;

    if (this.isUnit) return this.parentLocationId;

    if (this.isProject) return this.parentUnitId;

    return null;
  }

  set parentId(value) {
    if (this.isRegion) this.parentClientId = value;

    if (this.isLocation) this.parentRegionId = value;

    if (this.isUnit) this.parentLocationId = value;

    if (this.isProject) this.parentUnitId = value;
  }
}

